import Layout from '@/views/layout/Layout'
const designerRouter = {
    path: '/designer',
    name: 'designer',
    component: Layout,
    redirect: 'noRedirect',
    children: [
        // 设计师路由
        {
            path: '/designerIndex',
            name: 'designerIndex',
            component: () => import('@/views/designer/index'),
        },
        // 设计师详情页路由
        {
            path: '/designerDetail',
            name: 'designerDetail',
            component: () => import('@/views/designer/detail'),
        },
        // 设计师作品页路由
        {
            path: '/designerWorks',
            name: 'designerWorks',
            component: () => import('@/views/designer/works'),
        },
    ]
}
export default designerRouter


// WEBPACK FOOTER //
// ./src/router/modules/designer.js